const COLUMN_MIN_WIDTH = 70;

export const defaultOrderBy = {
  orderBy: 'createdDate',
  orderByDirection: 'descending',
};

export const baseColumnsDefaultConfigsBasic = [
  {
    id: 'createdDate',
    width: 125,
    minWidth: COLUMN_MIN_WIDTH,
    index: 0,
  },
  {
    id: 'delegationDate',
    width: 140,
    minWidth: COLUMN_MIN_WIDTH,
    index: 1,
  },
  {
    id: 'shipDate',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 2,
  },
  {
    id: 'status',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 3,
    nonsortable: true,
  },
  {
    id: 'orderNumber',
    width: 130,
    minWidth: COLUMN_MIN_WIDTH,
    index: 4,
  },
  {
    id: 'quantity',
    width: 93,
    minWidth: COLUMN_MIN_WIDTH,
    index: 5,
    nonsortable: true,
  },
  {
    id: 'batchName',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 6,
  },
  {
    id: 'tracking',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    index: 7,
  },
  {
    id: 'provider',
    width: 125,
    minWidth: COLUMN_MIN_WIDTH,
    index: 8,
  },
  {
    id: 'service',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    index: 9,
  },
  {
    id: 'recipient',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    index: 10,
  },
  {
    id: 'city',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 11,
  },
  {
    id: 'state',
    width: 73,
    minWidth: COLUMN_MIN_WIDTH,
    index: 12,
  },
  {
    id: 'country',
    width: 90,
    minWidth: COLUMN_MIN_WIDTH,
    index: 13,
  },
  {
    id: 'marketplaceNotified',
    width: 172,
    minWidth: COLUMN_MIN_WIDTH,
    index: 14,
  },
  {
    id: 'shipmentNotification',
    width: 180,
    minWidth: COLUMN_MIN_WIDTH,
    index: 15,
  },
];

export const otherColumnsDefaultConfigsBasic = [
  {
    id: 'amountPaid',
    width: 121,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'assignedTo',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'carrier',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'company',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'labelCreated',
    width: 130,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'orderDate',
    width: 107,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'packingSlipPrinted',
    width: 168,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'paidDate',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'postalCode',
    width: 116,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'shipmentNumber',
    width: 130,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'shippingPaid',
    width: 127,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'source',
    width: 86,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'store',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'taxPaid',
    width: 94,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'weight',
    width: 85,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
];

export const baseColumnsDefaultConfigsWithSort = [
  {
    id: 'createdDate',
    width: 125,
    minWidth: COLUMN_MIN_WIDTH,
    index: 0,
  },
  {
    id: 'delegationDate',
    width: 140,
    minWidth: COLUMN_MIN_WIDTH,
    index: 1,
  },
  {
    id: 'shipDate',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 2,
  },
  {
    id: 'status',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 3,
    nonsortable: true,
  },
  {
    id: 'orderNumber',
    width: 130,
    minWidth: COLUMN_MIN_WIDTH,
    index: 4,
  },
  {
    id: 'quantity',
    width: 93,
    minWidth: COLUMN_MIN_WIDTH,
    index: 5,
    nonsortable: true,
  },
  {
    id: 'batchName',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 6,
  },
  {
    id: 'tracking',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    index: 7,
  },
  {
    id: 'provider',
    width: 125,
    minWidth: COLUMN_MIN_WIDTH,
    index: 8,
  },
  {
    id: 'service',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    index: 9,
  },
  {
    id: 'recipient',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    index: 10,
  },
  {
    id: 'city',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    index: 11,
  },
  {
    id: 'state',
    width: 73,
    minWidth: COLUMN_MIN_WIDTH,
    index: 12,
  },
  {
    id: 'country',
    width: 90,
    minWidth: COLUMN_MIN_WIDTH,
    index: 13,
  },
  {
    id: 'marketplaceNotified',
    width: 172,
    minWidth: COLUMN_MIN_WIDTH,
    index: 14,
  },
  {
    id: 'shipmentNotification',
    width: 180,
    minWidth: COLUMN_MIN_WIDTH,
    index: 15,
  },
];

const otherColumnsDefaultConfigsWithSort = [
  {
    id: 'amountPaid',
    width: 121,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'assignedTo',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'carrier',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
  },
  {
    id: 'company',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'labelCreated',
    width: 130,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'orderDate',
    width: 107,
    minWidth: COLUMN_MIN_WIDTH,
  },
  {
    id: 'packingSlipPrinted',
    width: 168,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'paidDate',
    width: 100,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'postalCode',
    width: 116,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'shipmentNumber',
    width: 130,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'shippingPaid',
    width: 127,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'source',
    width: 86,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'store',
    width: 150,
    minWidth: COLUMN_MIN_WIDTH,
  },
  {
    id: 'taxPaid',
    width: 94,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
  {
    id: 'weight',
    width: 85,
    minWidth: COLUMN_MIN_WIDTH,
    nonsortable: true,
  },
];

export const defaultColumnConfigurationsBasic = [...baseColumnsDefaultConfigsBasic, ...otherColumnsDefaultConfigsBasic];

export const defaultColumnConfigurationsWithSort = [...baseColumnsDefaultConfigsWithSort, ...otherColumnsDefaultConfigsWithSort];
